import React from "react";
import TeamMemberCard from "./TeamMember";
import photo1 from "../resources/images/members/ЭС.jpg";
import photo2 from "../resources/images/members/Аида.png";
import photo5 from "../resources/images/members/АК.jpg";
import photo6 from "../resources/images/members/Бибигуль.png";
import photo7 from "../resources/images/members/Жұлдыз.jpeg";

const gapClasses =
  "gap-x-4 gap-y-4 md:gap-x-6 md:gap-y-4 lg:gap-x-8 lg:gap-y-4";

export const Members = () => {
  return (
    <section id="team" className="py-4 md:py-12 lg:py-20 font-montserrat">
      <div className="container mx-auto px-4 max-w-6xl">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-8 md:mb-12">
          Наша Команда
        </h2>

        {/* Ряд 1: Керимбаева — одна по центру */}
        <div className={`grid grid-cols-1 ${gapClasses} place-content-center justify-items-center mb-6 max-w-3xl mx-auto`}>
          <TeamMemberCard
            name="Керимбаева Эльмира Саметовна"
            position="Исполнительный директор по реализации услуг"
            imageUrl={photo1}
          />
        </div>

        {/* Ряд 2: Шарипбаева и Канатова */}
        <div className={`grid grid-cols-1 md:grid-cols-2 ${gapClasses} justify-items-center mb-6 max-w-3xl mx-auto`}>
          <TeamMemberCard
            name="Шарипбаева Бибигуль Баяновна"
            position="Методист академического отдела"
            imageUrl={photo6}
          />
          <TeamMemberCard
            name="Қанатова Жұлдыз Ерсайынқызы"
            position="Главный менеджер академического отдела"
            imageUrl={photo7}
          />
        </div>

        {/* Ряд 3: Оспанова и Ермекбаева */}
        <div className={`grid grid-cols-1 md:grid-cols-2 ${gapClasses} justify-items-center max-w-3xl mx-auto`}>
          <TeamMemberCard
            name="Оспанова Анар Капаровна"
            position="Руководитель проектного офиса по услугам"
            imageUrl={photo5}
          />
          <TeamMemberCard
            name="Ермекбаева Аида Талгатовна"
            position="Менеджер"
            imageUrl={photo2}
          />
        </div>

      </div>
    </section>
  );
};

export default Members;
